// Moved to components/Table/DataTable — nothing here was logs-specific.
//
// The copy here owned three things that are now props on the shared table, all supplied
// by LogsContainer: the red-on-ERROR row tint (`rowStyle`, previously a
// `rowConditionalFormatting` array whose entries past the first were silently ignored),
// the row click (`onRowClick`, previously a baked-in handleClick('display', id)), and the
// comma-joined array cells (`formatValue`).
export { default } from '../../Table/DataTable';
